import { render, staticRenderFns } from "./CardBasic.vue?vue&type=template&id=209092b0&scoped=true&"
import script from "./CardBasic.vue?vue&type=script&lang=js&"
export * from "./CardBasic.vue?vue&type=script&lang=js&"
import style0 from "./CardBasic.vue?vue&type=style&index=0&id=209092b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209092b0",
  null
  
)

export default component.exports